module.exports = __webpack_public_path__ + "static/media/user-remove-denied-male-asian.8ebbc3a2.png";